import React, {Fragment} from 'react'
import styled from '@emotion/styled'

import {isString, isNumber} from '../../../../universal-src/util'
import {pluralizeStr} from '../../format/Plural'
import {numWithSpaces, formatNum} from '../../format/Number/'

const Root = styled.div`
  display: flex;
  align-items: baseline;
`

const Value = styled.div`
  color: ${({warning}) => warning ? '#ef1f15' : 'rgba(255, 255, 255, 0.65)'};
  font: 11px/2 Merriweather, serif;
  cursor: ${({title}) => title ? 'help' : 'auto'};
`

const Label = styled.div`
  padding-left: ${({noSpace}) => noSpace ? '0' : '5px'};
  cursor: ${({title}) => title ? 'help' : 'auto'};
  font-size: 11px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.3);
`

const Link = styled.a`
  color: inherit;
  text-decoration: none;
  border: none;
`

const Stat = ({
  value,
  label,
  title = null,
  pluralize = true,
  noSpace = false,
  currency = null,
  minWarning = null,
  valueHint = false,
  hintCurrency = null,
  link = null
}) => {
  let processedValue = value
  let warning = false

  if (isNumber(value)) {
    if (value < minWarning) warning = true
    processedValue = numWithSpaces(parseInt(value))
    if (valueHint) title = formatNum(value) + (hintCurrency ? ` ${hintCurrency}` : '')
  }

  let processedLabel = isString(label) && pluralize ? pluralizeStr(label, value) : label
  processedValue = <Fragment>{processedValue}{currency && ` ${currency}`}</Fragment>

  if (link) {
    processedLabel = <Link href={link}>{processedLabel}</Link>
    processedValue = <Link href={link}>{processedValue}</Link>
  }

  return <Root>
    <Value warning={warning} title={title}>{processedValue}</Value>
    <Label noSpace={noSpace} title={title}>{processedLabel}</Label>
  </Root>
}

export default Stat
